import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/fono';
export function Testimonials() {
  return <section className="border-y-4 border-mint bg-white px-3 py-5 sm:py-7" data-id="element-175" data-mp="3krp59519wxqc">
      <div className="mx-auto max-w-4xl" data-id="element-176" data-mp="3fyvxe8aid9a1">
        <h2 className="text-center text-xl leading-tight text-teal sm:text-3xl" data-id="element-177" data-mp="3fxku09kz63jg">
          What speech-language professionals are saying
        </h2>

        <div className="mt-3 grid gap-2.5 sm:grid-cols-2" data-id="element-178" data-mp="36z96whjbhnvr">
          {testimonials.map((t, i) => <figure key={t.author} className={`flex flex-col rounded-lg border border-teal/15 bg-cream p-3.5 shadow-sm ${i === 0 ? 'sm:col-span-2' : ''}`} data-id="element-179" data-mp="31zmrq2jxhxkb" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="Rated 5 out of 5" data-id="element-180" data-mp="2s39qmjm20hfj">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-mustard text-mustard" aria-hidden="true" data-id="element-181" data-mp="qac2h1382d0x" data-mpi={s} />)}
              </div>
              <blockquote className="mt-1.5 text-[13px] font-medium italic leading-snug text-charcoal sm:text-[15px]" data-id="element-182" data-mp="m5klwo4j6tcf">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-2.5 pt-2.5" data-id="element-183" data-mp="7a4uyrz8zdk9">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-mint font-display text-base font-extrabold text-teal" data-id="element-184" data-mp="c8y0ny8am09v">
                  {t.author.charAt(0)}
                </span>
                <span className="leading-tight" data-id="element-185" data-mp="14xddce3yc6i1">
                  <span className="block text-[13px] font-extrabold text-teal" data-id="element-186" data-mp="q5l6yrm4y2sg">
                    {t.author}
                  </span>
                  <span className="block text-[10px] font-semibold uppercase tracking-wide text-charcoal/60" data-id="element-187" data-mp="v3mqfdnh444g">
                    {t.role} — {t.location}
                  </span>
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}